import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { createUseStyles } from "react-jss";
import showImageSkin from "../../../../skins/show-image.skin";
import { getUploadOneViewUrl } from "../../../../utils/urls";
import i18n from "../../../../utils/locale/i18n";

const useStyles = createUseStyles(showImageSkin);

function UploadOneShowFile({ value, fieldOptions, onDelete }) {
  const showImagePreview = useSelector(
    (state) => state.configuration.showImagePreview
  );

  const classes = useStyles();

  const filenamePublicPath = getUploadOneViewUrl({
    fieldOptions,
    filename: value,
  });

  return (
    <div>
      <a href={filenamePublicPath} target="_blank" rel="noreferrer">
        {showImagePreview && /(\.jpg|\.jpeg|\.png|\.gif)$/i.test(value) ? (
          <img
            src={filenamePublicPath}
            alt={value}
            className={classes["image-preview"]}
          />
        ) : (
          value
        )}
      </a>
      &nbsp;&nbsp;
      <button
        className="btn btn-default btn-outline-dark"
        type="button"
        onClick={onDelete}
      >
        <i className="fas fa-trash"></i>&nbsp;{i18n.t("action_delete")}
      </button>
    </div>
  );
}

UploadOneShowFile.propTypes = {
  className: PropTypes.string,
  control: PropTypes.object,
  domType: PropTypes.string,
  domStep: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
};

export default UploadOneShowFile;
